import {
    apiStockList,
    apiStockTrendings,
    apiStockQuote,
    getSummaryBySecurityID,
    getPresentBySecurityID,
    apiFindShareHolder,
    apiFindFundQuote,
    apiStockNav,
    apiStockFilter,
    apiStockCategories,
    apiStockCard,
    apiStockVerify
} from "../../api/stock.js";
import axios from 'axios'
import moment from 'moment'
import * as constant from './constant'
const objPeriod = {
    "1D": {
        count: 1,
        typeOfPeriod: "day",
    },
    "1W": {
        count: 1,
        typeOfPeriod: "week",
    },
    "1M": {
        count: 1,
        typeOfPeriod: "month",
    },
    "3M": {
        count: 3,
        typeOfPeriod: "months",
    },
    "6M": {
        count: 6,
        typeOfPeriod: "months",
    },
    "1Y": {
        count: 1,
        typeOfPeriod: "year",
    },
    "3Y": {
        count: 3,
        typeOfPeriod: "years",
    },
    "5Y": {
        count: 5,
        typeOfPeriod: "years",
    },
    "10Y": {
        count: 10,
        typeOfPeriod: "years",
    },
}
export const actions = {
    async findStockList({ commit }) {
        const rs = await apiStockList();
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.STOCK_LIST, data)
            }
        }
    },

    async findStockCategories({ commit }) {
        const rs = await apiStockCategories();
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                let arr = []
                for (let i = 0; i < data.length; i++) {
                    let sector = data[i].Sector
                    let children = data[i].Child

                    let arrChild = []
                    children.map(({
                        SectorNumber,
                        SectorNameTh
                    }) => {
                        let obj = {
                            title: SectorNameTh,
                            value: SectorNumber,

                        }
                        arrChild = [...arrChild, obj]
                    })

                    let obj = {
                        title: sector.SectorNameTh,
                        value: sector.IndustryNumber,
                        children: arrChild
                    }
                    arr.push(obj)
                }
                await commit(constant.STOCK_CATEGORIES, arr)
            }
        }
    },

    async findStockTrendingList({ commit }) {
        const rs = await apiStockTrendings();
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.STOCK_TRENDING_LIST, data)
            }
        }
    },
    async findStockQuote({ commit, state }, params) {
        if (state.stockQuote.name === params) return true // user select current data
        if (params) params = params.toUpperCase()
        const rs = await apiStockQuote(params)
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data && typeof (data) !== 'string') {
                await commit(constant.STOCK_QUOTE, data)
                return true
            }
            return false
        }

    },
    async findStockBySecurityID({ commit }, { securityID, fiscal }) {
        try {
            axios.all([
                getSummaryBySecurityID({ securityID, fiscal }),
                getPresentBySecurityID(securityID)
            ])
                .then(axios.spread(function (summary, present) {
                    var value = {
                        data: summary.data.length ? summary.data : {},
                        present: present.data ? present.data[0] : {}
                    }
                    commit(constant.STOCK_FINANCIAL_CARD, { key: securityID, value: value })
                }));
        } catch (err) {
            throw new Error(err.message)('store_stock_find_stock_by_security_ID', err.message)
        }
    },
    async findShareHolder({ commit }, securityID) {
        try {
            const rs = await apiFindShareHolder(securityID)
            if (rs && rs.status == 200) {
                commit(constant.STOCK_SHAREHOLDER, { data: rs.data })
            }
        } catch (err) {
            throw new Error(err.message)("GET share holder:", err.message)
        }
    },
    async findStockGraphPeriod({ commit }, securityID) {
        const rs = await apiStockVerify(securityID);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.STOCK_GRAPH_PERIOD, data)
                await commit(constant.STOCK_PERIOD, data.default_period)
                return true
            }
        }
        return false
    },
    async findFundQuote({ commit }, stockName) {
        try {
            const rs = await apiFindFundQuote(stockName)
            if (rs && rs.status == 200) {
                commit(constant.STOCK_FUND_QUOTE, { data: rs.data })
            }
        } catch (err) {
            throw new Error(err.message)("GET fund quote", err.message)
        }
    },
    async findStockNav({ commit, getters }, { stockName, period }) {
        let to = moment().unix();
        let from = moment().subtract(1, "years").unix();
        switch (period) {
            case "YTD":
                from = moment().startOf('years').unix()
                break;
            case 'MAX':
                from = moment("1950-01-01T00:00:00").unix()
                break;
            default:
                const { count, typeOfPeriod } = objPeriod[period];
                from = moment().subtract(count, typeOfPeriod).unix();
                break;
        }

        if (period == "1D" && getters.getStockQuote) {
            let lastDataDate = getters.getStockQuote.date.split('/')
            let tranfromDate = lastDataDate[1] + '/' + lastDataDate[0] + '/' + lastDataDate[2];
            let targetDate = new Date(tranfromDate);
            targetDate.setDate(targetDate.getDate() - 5);
            from = targetDate.getTime() / 1000
            to = moment().unix()
        }
        const obj = {
            stockName,
            to: to,
            from: from,
            period: period
        }
        const rs = await apiStockNav(obj);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                if (period == '1D') {
                    data.c = data.c.slice(data.c.length - 2)
                    data.h = data.h.slice(data.h.length - 2)
                    data.l = data.l.slice(data.l.length - 2)
                    data.o = data.o.slice(data.o.length - 2)
                    data.t = data.t.slice(data.t.length - 2)
                    data.v = data.v.slice(data.v.length - 2)
                }
                await commit(constant.STOCK_NAV, data)
            }
        }
    },
    async findStockShareData({ commit }, { stockName, period }) {
        const { count, typeOfPeriod } = objPeriod[period]
        let to = moment().unix()
        let from = moment().subtract(count, typeOfPeriod).unix()
        await commit(constant.STOCK_TIMESTAMP_1D, { to: to, from: from })
        const obj = {
            stockName,
            to: to,
            from: from
        }
        const rs = await apiStockNav(obj);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.STOCK_NAV_1D, data)
            }
        }
    },
    async saveStockPeriod({ commit }, period) {
        await commit(constant.STOCK_PERIOD, period)
    },
    async saveStockUnitType({ commit }, type) {
        await commit(constant.STOCK_UNIT_TYPE, type)
    },
    showStockChartModal({ commit }, data) {
        commit(constant.TOGGLE_CHART_MODAL, true)
        // commit(constant.TOGGLE_CHART_MODAL, false)
        commit(constant.SET_CHART_DATA, data)
    },
    closeChartModal({ commit }) {
        commit(constant.TOGGLE_CHART_MODAL, false)
    },
    async findStockFilter({ commit }, { payload, period }) {
        const rs = await apiStockFilter(payload);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.STOCK_RANKING, { payload: data, period })
            }
        }
    },
    async findStockFollowing({ commit }) {
        // const rs = await apiIndiceList();
        let mockData = [
            {
                name: "CPN",
                data_date: "2019-01-01",
                price: 109,
                period: "1D",
                percent: 1.22
            },
            {
                name: "BTS",
                data_date: "2019-01-01",
                price: 109,
                period: "1D",
                percent: -2.0
            },
            {
                name: "CPALL",
                data_date: "2019-01-01",
                price: 109,
                period: "1D",
                percent: 1.22
            }
        ]
        await commit(constant.STOCK_FOLLOWING, mockData)

    },
    async updateStockFollowing({ commit }, payload) {
        await commit(constant.STOCK_FOLLOWING, payload)
    },

    async sendStockCard({ commit }, payload) {
        try {
            const rs = await apiStockCard(payload);
            if (rs && rs.status == 200) {
                let data = rs.data.data.saved
                if (data) {
                    return data
                }
            }
        } catch (error) {
            throw new Error(error)
        }
    },
}